module.exports = __webpack_public_path__ + "img/gaurav.4988627b.jpeg";